import {
    GET_RETURN_AUTHORIZATION_REPORT_REQUEST,
    GET_RETURN_AUTHORIZATION_REPORT_SUCCESS,
    GET_RETURN_AUTHORIZATION_REPORT_ERROR,
    GET_RETURN_BULK_PENDING_REPORT_REQUEST,
    GET_RETURN_BULK_PENDING_REPORT_SUCCESS,
    GET_RETURN_BULK_PENDING_REPORT_ERROR
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";
const axios = require("axios");

export const getReturnAuthorizationReport = (token, values) => (dispatch) => {
    dispatch({ type: GET_RETURN_AUTHORIZATION_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/BulkReturnsReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            customer_id: (values.customer === undefined || values.customer === "All") ? null : values.customer,
            region_id: (values.region_id === undefined || values.region_id === "All") ? null : values.region_id,
            gender_id: (values.gender_id === undefined || values.gender_id === "All") ? null : values.gender_id,
            payment_term_id: (values.term_id === undefined || values.term_id === "All") ? null : values.term_id,
            location_id: (values.location_id === undefined || values.location_id === "All") ? null : values.location_id,
            sales_person_id: (values.salesperson_id === undefined || values.salesperson_id === "All") ? null : values.salesperson_id,
            ra_no: values.ra_approval === undefined ? null : values.ra_approval,
            lot_no: values.lot_no === undefined ? null : values.lot_no,
            sku: values.sku === undefined ? null : values.sku,
            date_from: moment(values.from_date).format("MM-DD-YYYY"),
            date_to: moment(values.to_date).format("MM-DD-YYYY"),
        }
    })
        .then((response) => {
            return dispatch({ type: GET_RETURN_AUTHORIZATION_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_RETURN_AUTHORIZATION_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_RETURN_AUTHORIZATION_REPORT_ERROR,
                payload: error.response,
            });
        });
};

export const getReturnBulkPendingReport = (token, values) => (dispatch) => {
    dispatch({ type: GET_RETURN_BULK_PENDING_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/BulkReturnsPending`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            customer_id: (values.customer === undefined || values.customer === "All") ? null : values.customer,
            region_id: (values.region_id === undefined || values.region_id === "All") ? null : values.region_id,
            gender_id: (values.gender_id === undefined || values.gender_id === "All") ? null : values.gender_id,
            payment_term_id: (values.term_id === undefined || values.term_id === "All") ? null : values.term_id,
            location_id: (values.location_id === undefined || values.location_id === "All") ? null : values.location_id,
            sales_person_id: (values.salesperson_id === undefined || values.salesperson_id === "All") ? null : values.salesperson_id,
            ra_no: values.ra_approval === undefined ? null : values.ra_approval,
            lot_no: values.lot_no === undefined ? null : values.lot_no,
            sku: values.sku === undefined ? null : values.sku,
            date_from: moment(values.from_date).format("MM-DD-YYYY"),
            date_to: moment(values.to_date).format("MM-DD-YYYY"),
        }
    })
        .then((response) => {
            return dispatch({ type: GET_RETURN_BULK_PENDING_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_RETURN_BULK_PENDING_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_RETURN_BULK_PENDING_REPORT_ERROR,
                payload: error.response,
            });
        });
};
